import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import AlertModal from './components/AlertModal';
import Home from './pages/Home';
import OSA from './pages/OSA';
import OSATable from './pages/OSATable';
import Schedule from './pages/Schedule';
import GoodToKnow from './pages/GoodToKnow'
import Speeches from './pages/Speeches';
import Gifts from './pages/Gifts';
import './App.css';
import { preload } from 'swr';
import { fetcher } from './lib/fetcher.js'

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [password, setPassword] = useState('');
    const [showAlert, setShowAlert] = useState(false);

    preload('/api/reserve', fetcher);

    function prefetchImages(images) {
        images.forEach((src) => {
            const img = new Image();
            img.src = src;
        });
    }

    useEffect(() => {
        prefetchImages([
            "/homePicture.png",
            "/vigsel.png",
            "/foodDrinks.png",
            "/dresscode.png",
            "/accomodation.png",
            "/kid.png",
            "/speechpicture.png"
        ]);
    }, []);

    const checkPassword = () => {
        if (password === process.env.REACT_APP_PASSWORD) {
            setIsAuthenticated(true);
        } else {
            setShowAlert(true);
        }
    };

    if (!isAuthenticated && !process.env.REACT_APP_IS_DEV) {
        return (
            <div className="login-wrapper">
                <div className='login-card-wrapper'>
                    <div className="login-card">
                        <h1 className="home-main-text">Välkommen</h1>
                        <p className="home-text">Vänligen ange lösenordet från inbjudan</p>
                        <input
                            type="password"
                            className="login-input"
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Lösenord..."
                            onKeyDown={(e) => e.key === 'Enter' && checkPassword()}
                            autocomplete="new-password"
                        />
                        <button className="login-button" onClick={checkPassword}>
                            Logga In
                        </button>
                    </div>
                </div>
                <AlertModal
                    isOpen={showAlert}
                    title="Felaktigt Lösenord!"
                    message="Lösenordet du angav är inte korrekt. Vänligen försök igen."
                    confirmText="OK"
                    onConfirm={() => setShowAlert(false)}
                />
            </div>
        );
    }

    return (
        <Router>
            <Navbar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/osa" element={<OSA />} />
                <Route path="/osa-tabell" element={<OSATable />} />
                <Route path="/schema" element={<Schedule />} />
                <Route path="/bra-att-veta" element={<GoodToKnow />} />
                <Route path="/tal" element={<Speeches />} />
                <Route path="/gåvor" element={<Gifts />} />
            </Routes>
        </Router>
    );
}

export default App;
